module.exports = __webpack_public_path__ + "img/soya.9327d7e0.png";